import Downshift from "downshift";

export default function defaultStateReducer(state, changes) {
  switch (changes.type) {
    case Downshift.stateChangeTypes.controlledPropUpdatedSelectedItem: {
      return {
        ...changes,
        inputValue: "",
        isOpen: true,
        highlightedIndex: 0,
      };
    }
    case Downshift.stateChangeTypes.changeInput: {
      return {
        ...changes,
        highlightedIndex: 0,
      };
    }
    case Downshift.stateChangeTypes.keyDownArrowDown: {
      if (changes.highlightedIndex === null) {
        return {
          ...changes,
          highlightedIndex: 0,
        };
      }

      return changes;
    }
    default: {
      return changes;
    }
  }
}
